import { jsx } from "react/jsx-runtime";
import { MyAccountLinkSession } from "./MyAccountLinkSession.js";
import { AccountView } from "./view.account.js";
function MyAccountLink({
  dataTestId = "",
  entry,
  locale
}) {
  if (!entry) return null;
  return /* @__PURE__ */ jsx(
    MyAccountLinkSession,
    {
      AccountView: /* @__PURE__ */ jsx(
        AccountView,
        {
          dataTestId,
          entry,
          locale
        }
      ),
      dataTestId,
      entry,
      locale
    }
  );
}
export {
  MyAccountLink
};
